import { DomSanitizer } from '@angular/platform-browser';

import { SafeResourceUrlService } from '../../../services/safe-resource-url.service';

let domSanitizer: DomSanitizer;
let safeResourceUrlService: SafeResourceUrlService;

export const setDOMSanitizer = (sane) => {
  domSanitizer = sane;
};

export const setSafeResourceUrlService = (service) => {
  safeResourceUrlService = service;
};

export const getIconURL = (file) => {
  const contentType = file.contentType || file.fileProperties.contentType;
  if (file.id) {
    return safeResourceUrlService.toSafeUrl(
      'assets/img/icons/' + contentType.substr(contentType.indexOf('/') + 1) + '.svg'
    );
  } else {
    return safeResourceUrlService.toSafeUrl(
      'assets/img/icons/' + (file.fileType || file.type).substr((file.fileType || file.type).indexOf('/') + 1) + '.svg'
    );
  }
};

export const formatSizeUnits = (bytes) => {
  if (bytes >= 1073741824) {
    bytes = (bytes / 1073741824).toFixed(2) + ' GB';
  } else if (bytes >= 1048576) {
    bytes = (bytes / 1048576).toFixed(2) + ' MB';
  } else if (bytes >= 1024) {
    bytes = (bytes / 1024).toFixed(2) + ' KB';
  } else if (bytes > 1) {
    bytes = bytes + ' bytes';
  } else if (bytes == 1) {
    bytes = bytes + ' byte';
  } else {
    bytes = '0 byte';
  }
  return bytes;
};
